export default {
  login: {
    title: 'Entrar',
    usernameLabel: 'Nome de usuário',
    usernamePlaceholder: '2-10 dígitos em inglês',
    loginPasswordLabel: 'Senha de login',
    loginPasswordPlaceholder: 'Por favor, insira sua senha de login',
    googleCodeLabel: 'Código de verificação do Google',
    googleCodePlaceholder:
      'Por favor, insira um código de verificação do Google de 6 dígitos',
    hasNoAccount: 'Ainda não tem conta,',
    goRegister: 'Ir para registrar',
    onlineCustom: 'Atendimento online',
    loginArgument: 'Continuar a entrar significa concordar com',
    userArgument: '《Acordo de Usuário》',
    registerNotEnabled:
      'A função de registro não está aberta, entre em contato com o administrador',
    usernameRequired: 'Por favor, insira um nome de usuário correto',
    loginPasswordRequired: 'Por favor, insira a senha de login correta',
    googleCodeRequired:
      'Por favor, insira o código de verificação do Google correto',
    loginButton: 'Entrar'
  },
  register: {
    title: 'Registrar',
    usernameLabel: 'Nome de usuário',
    usernamePlaceholder: 'Por favor, insira o nome de usuário registrado',
    loginPasswordLabel: 'Senha de login',
    loginPasswordPlaceholder:
      'Por favor, insira a senha de login do usuário registrado',
    loginPasswordPreLabel: 'Confirmar senha de login',
    loginPasswordPrePlaceholder: 'Por favor, insira a senha de login novamente',
    fudPasswordLabel: 'Senha de fundos',
    fudPasswordPlaceholder: 'Por favor, insira a senha de fundos',
    inviteCodeLabel: 'Código de convite',
    inviteCodePlaceholder:
      'Por favor, insira um código de convite de 6 dígitos',
    registerNeed: 'Continuar a registrar significa concordar com',
    registerArgument: '《Acordo de Registro》',
    usernameRequired: 'Por favor, insira um nome de usuário correto',
    loginPasswordRequired: 'Por favor, insira a senha de login correta',
    loginPasswordPreRequired:
      'Por favor, insira a confirmação correta da senha de login',
    fundPasswordRequired: 'Por favor, insira a senha de fundos correta',
    inviteCodeRequired: 'Por favor, insira o código de convite correto',
    diffLoginPasswordError: 'As duas senhas de login não coincidem',
    registerSuccess: 'Registro bem-sucedido',
    registerButton: 'Registrar',
    emailLabel: 'E-mail',
    emailPlaceholder: 'Por favor, insira seu endereço de e-mail',
    emailCodeLabel: 'Código de verificação',
    emailCodePlaceholder:
      'Por favor, insira o código de verificação enviado por e-mail',
    second: 'segundo',
    getEmailCodeButton: 'Obter código',
    emailRequired:
      'Por favor, insira um endereço de e-mail correto e tente novamente',
    emailCodeRequired:
      'Por favor, insira o código de verificação correto enviado por e-mail e tente novamente'
  },
  home: {
    hotCoin: {
      title: 'Ofertas Populares',
      more: 'Mais'
    },
    poster: {
      title: 'Depósito rápido',
      enter: 'Entrar agora >',
      subTitle: 'Suporte para BTC, USDT, ETH, etc.'
    },
    quickMenus: {
      futuresTrading: 'Negociação de Futuros',
      helpCenter: 'Central de Ajuda'
    },
    ranking: {
      increase: {
        title: 'Lista de Altas'
      },
      clinch: {
        title: 'Lista de Volume'
      }
    }
  },
  tabBar: {
    home: 'Início',
    price: 'Mercado',
    trade: 'Negociar',
    fund: 'Ativo',
    user: 'Perfil'
  },
  currency: {
    favorite: 'Favorito',
    allCurrency: 'Spot',
    dayVol: '24H',
    addFavor: '+ Adicionar Favorito'
  },
  trade: {
    bills: 'Faturas',
    todayOpen: 'Abrir',
    star: 'Favorito',
    vol: 'Volume',
    low: 'Mais Baixo',
    high: 'Mais Alto',
    timing: 'Tempo',
    spot: 'Futuros',
    buyMore: 'Comprar Mais',
    buyEmpty: 'Vender',
    indicator: 'Indicador',
    indicatorSettings: 'Configurações do Indicador',
    balance: 'Meu saldo',
    fee: 'Taxa de Serviço',
    ruleIdError: 'Por favor, selecione um prazo de expiração',
    deleteFavoriteSuccess: 'Favorito removido com sucesso',
    addFavoriteSuccess: 'Favorito adicionado com sucesso',
    buyIn: 'Comprar',
    sellOut: 'Vender',
    holding: 'Mantendo',
    history: 'Histórico',
    spotOrderConfirm: {
      title: 'Confirmar Compra',
      amountPlaceholder: 'Por favor, insira a quantidade para comprar'
    },
    spotTradeOrder: {
      holding: {
        coin: 'moeda',
        buyInAmountPrice: 'Quantidade/Preço de Compra',
        buyInCount: 'Quantidade',
        actions: 'Ação',
        sellOut: 'Vender',
        profit: 'Lucro'
      }
    },
    orderConfirm: {
      title: 'Confirmar Pedido',
      coinName: 'Moeda',
      direction: 'Direção',
      price: 'Preço',
      balance: 'Saldo',
      fee: 'Taxa de Serviço',
      buyMoreLabel: 'Comprar Mais',
      buyEmptyLabel: 'Vender',
      buyQuantity: 'Quantidade de Compra',
      buyAmount: 'Valor da Compra',
      submit: 'Confirmar Pedido'
    },
    kline: {
      open: 'Abrir:',
      close: 'Fechar:',
      change: 'Alteração:'
    }
  },
  finance: {
    title: 'Finanças'
  },
  allFinance: {
    title: 'Gestão Financeira',
    all: 'Tudo'
  },
  financeOrders: {
    title: 'Pedido de Penhor',
    holdingLabel: 'Mantendo',
    historyLabel: 'Histórico',
    holding: {
      amount: 'Quantia empenhada',
      rateStr: 'Valor do rendimento/rendimento',
      vcCount: 'Número de moedas empenhadas',
      cycle: 'Ciclo da posição',
      day: 'Dia',
      calcStartDate: 'Data de início do valor',
      serviceAmount: 'Taxa de Serviço',
      redeemOrder: 'Resgatar'
    },
    history: {
      incomeAmount: 'Valor do rendimento',
      rateStr: 'Rendimento',
      amount: 'Quantia empenhada',
      vcCount: 'Número de moedas empenhadas',
      calcStartDate: 'Data de início do valor',
      calcEndDate: 'Data de término',
      cycle: 'Dias do ciclo',
      serviceAmount: 'Taxa de Serviço',
      day: 'dia'
    }
  },
  financeOrderBills: {
    title: 'Fatura de Rendimento do Penhor',
    amount: 'Quantia',
    balance: 'Saldo'
  },
  financeItem: {
    rateStr: 'Rendimento',
    buyType: 'Tipo de Compra',
    cycle: 'Dias do ciclo',
    exchangeRate: 'Taxa de câmbio (troca de moeda virtual por saldo)',
    day: 'dia',
    cycleType: 'Tipo de ciclo',
    serviceRateStr: 'Taxa de Serviço'
  },
  buyFinance: {
    title: 'Comprar',
    rateStr: 'Rendimento',
    name: 'Nome',
    buyType: 'Tipo de Compra',
    cycle: 'Dias do ciclo',
    cycleType: 'Tipo de ciclo',
    exchangeRate: 'Taxa de câmbio (troca de moeda virtual por saldo)',
    serviceRateStr: 'Taxa de Serviço',
    remark: 'Observação',
    buyAmountLabel: 'Quantia de Compra ({coin})',
    descriptionTitle: 'Descrição do Produto',
    descriptionPart1:
      '1. Este produto é um produto de gestão de riqueza sem garantia de capital. Flutuações de mercado podem levar a perdas de capital. Invista com cuidado.',
    descriptionPart2: '2. Regras de liquidação de pagamento:',
    descriptionPart3:
      'Se o preço de liquidação < preço vinculado, o BTC será liquidado após o vencimento; quantia de liquidação = quantia investida * (1+ dias * taxa de retorno anualizada / 365).',
    descriptionPart4:
      'Se o preço de liquidação ≥ preço vinculado, o USDT será liquidado após o vencimento; quantia de liquidação = quantia investida * preço vinculado * (1+ dias * taxa de retorno anualizada / 365).',
    descriptionPart5:
      '3. A taxa de retorno anualizada real muda em tempo real com o mercado, consulte a transação de compra real.',
    descriptionPart6:
      '4. A quantia investida é convertida de acordo com o mercado em tempo real, consulte a transação de compra real.',
    descriptionPart7:
      '5. Após a compra do produto, ele pode ser visualizado na página de detenção de moeda e o reembolso será automaticamente emitido para a conta spot após a data de vencimento.',
    buyButton: 'Comprar [{coin}]'
  },
  fund: {
    description: 'Ativos',
    recharge: 'Recarregar',
    withdraw: 'Retirar',
    exchange: 'Transferir',
    empty: 'Carteira vazia, vá'
  },
  userCenter: {
    lastLogin: 'Último login',
    myTeam: 'Minha Equipe',
    identity: 'Autenticação',
    walletAddress: 'Endereço da Carteira',
    zskAccount: 'Conta ZSK',
    bankCard: 'Conta Bancária',
    userBills: 'Faturas do Usuário',
    timingTradeOrder: 'Pedido de Negociação Temporizada',
    spotTradeOrder: 'Pedido de Negociação Futura',
    contactTradeOrder: 'Posição do Contrato',
    userReport: 'Relatório do Usuário',
    teamReport: 'Relatório da Equipe',
    share: 'Compartilhar',
    customer: 'Atendimento ao Cliente',
    helpCenter: 'Central de Ajuda',
    platform: 'Introdução à Plataforma',
    profit: 'Lucro',
    balance: 'Saldo',
    withdraw: 'Retirar',
    recharge: 'Recarregar',
    creditStoreLabel: 'Loja de Crédito'
  },
  settings: {
    title: 'Configurações',
    fundPassword: 'Senha de Fundos',
    googleValidator: 'Validador do Google',
    editLoginPassword: 'Alterar Senha de Login',
    switchLocale: 'Alterar Idioma'
  },
  editFundPassword: {
    title: 'Alterar Senha de Fundos',
    currentPasswordLabel: 'Senha Atual',
    currentPasswordPlaceholder: 'Por favor, insira a senha de fundos atual',
    newPasswordLabel: 'Nova Senha',
    newPasswordPlaceholder: 'Por favor, insira a nova senha de fundos',
    prePasswordLabel: 'Confirmar Senha',
    prePasswordPlaceholder: 'Digite novamente a nova senha de fundos',
    tips:
      'A senha de fundos é uma credencial importante para transações. Por favor, configure-a cuidadosamente e memorize-a.',
    currentPasswordRequired: 'Por favor, insira a senha de fundos atual',
    newPasswordRequired: 'Por favor, insira a senha de fundos a ser alterada',
    prePasswordRequired:
      'Por favor, insira novamente a senha de fundos a ser alterada',
    prePasswordDiff: 'As duas entradas de senha não coincidem'
  },
  bindFundPassword: {
    title: 'Vincular Senha de Fundos',
    fundPasswordLabel: 'Senha de Fundos',
    fundPasswordPlaceholder: 'Por favor, insira a senha de fundos',
    fundPasswordPreLabel: 'Confirmar Senha',
    fundPasswordPrePlaceholder: 'Por favor, insira novamente a senha de fundos',
    fundPasswordRequired: 'A senha de fundos é obrigatória',
    fundPasswordPreRequired: 'Confirmar senha é obrigatório',
    fundPasswordDiff: 'As duas entradas de senha não coincidem',
    bindSuccess: 'Vinculação Bem-Sucedida',
    tips:
      'A senha de fundos é uma credencial importante para transações. Por favor, configure-a cuidadosamente e memorize-a.'
  },
  editLoginPassword: {
    title: 'Alterar Senha de Login',
    currentPasswordLabel: 'Senha Atual',
    currentPasswordPlaceholder: 'Por favor, insira a senha de login atual',
    newPasswordLabel: 'Nova Senha',
    newPasswordPlaceholder: 'Por favor, insira a nova senha de login',
    prePasswordLabel: 'Confirmar Senha',
    prePasswordPlaceholder: 'Digite novamente a nova senha de login',
    tips:
      'A senha de login é uma credencial importante para autenticação. Configure-a com cuidado e memorize-a.',
    currentPasswordRequired: 'Por favor, insira a senha de login atual',
    newPasswordRequired: 'Por favor, insira a senha de login a ser alterada',
    prePasswordRequired:
      'Por favor, insira novamente a senha de login a ser alterada',
    prePasswordDiff: 'As duas entradas de senha não coincidem'
  },
  bindGoogleValidator: {
    title: 'Vincular Autenticador do Google',
    qrCodeLabel: 'QR Code',
    keyLabel: 'Chave',
    loginPasswordLabel: 'Senha de Login',
    loginPasswordPlaceholder: 'Por favor, insira sua senha de login',
    googleCodeLabel: 'Código de Verificação do Google',
    googleCodePlaceholder: 'Por favor, insira um código de 6 dígitos do Google',
    tipsPart1: 'Pesquise por Google Authenticator na loja de aplicativos',
    tipsPart2:
      'Use o Google Authenticator para escanear o QR Code acima ou insira manualmente a chave para vinculação',
    tipsPart3:
      'Insira o código de verificação de 6 dígitos do Google acima e clique em Confirmar para enviar',
    loginPasswordRequired: 'Por favor, insira a senha de login',
    googleCodeRequired:
      'Por favor, insira um código de verificação de 6 dígitos do Google'
  },
  walletAddress: {
    title: 'Endereço da Carteira',
    add: '+ Adicionar Endereço',
    remark: 'Observação',
    addButton: 'Adicionar endereço da carteira',
    tips:
      'Se você deseja modificar ou excluir informações de endereço, entre em contato com o atendimento ao cliente'
  },
  addWalletAddress: {
    title: 'Adicionar endereço da carteira',
    vcChainNameIdLabel: 'Tipo de cadeia',
    vcAccountLabel: 'Endereço da carteira',
    vcAccountPlaceholder: 'Por favor, insira o endereço da carteira',
    remarkLabel: 'Observações',
    remarkPlaceholder: 'Por favor, insira o conteúdo da observação',
    fundPasswordLabel: 'Senha de fundos',
    fundPasswordPlaceholder: 'Por favor, insira sua senha de fundos',
    tips:
      'O endereço da carteira adicionado não pode ser modificado, por favor, verifique se as informações estão corretas',
    vcIdRequired: 'Por favor, selecione a moeda correta',
    vcChainNameIdRequired: 'Por favor, selecione o tipo de cadeia correto',
    vcAccountRequired: 'Por favor, insira o endereço da carteira correto',
    fundPwdRequired: 'Por favor, insira a senha de fundos correta',
    addSuccess: 'Endereço da carteira adicionado com sucesso'
  },
  receiveWays: {
    title: 'Meu cartão bancário',
    add: '+ Adicionar cartão bancário',
    tips:
      'Se você deseja modificar ou excluir as informações do cartão bancário, entre em contato com o atendimento ao cliente',
    addCardButton: 'Adicionar cartão bancário'
  },
  zskAccount: {
    title: 'Conta rápida',
    add: '+ Adicionar conta rápida',
    tips:
      'Para modificar ou excluir informações da conta, entre em contato com o atendimento ao cliente',
    addCardButton: 'Adicionar conta'
  },
  addZskAccount: {
    title: 'Adicionar uma conta rápida',
    withdrawNameLabel: 'Nome',
    withdrawNamePlaceholder: 'Por favor, insira o nome',
    withdrawNameRequired: 'O nome é obrigatório',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Por favor, insira a velocidade rápida',
    fundPasswordLabel: 'Senha de fundos',
    fundPasswordPlaceholder: 'Por favor, insira sua senha de fundos',
    tips:
      'Por favor, preencha cuidadosamente as informações da conta adicionada. A empresa não se responsabiliza por problemas devido a informações incorretas'
  },
  addBankCard: {
    title: 'Adicionar um novo cartão bancário',
    withdrawNameLabel: 'Nome',
    withdrawNamePlaceholder: 'Por favor, insira o nome',
    withdrawNameRequired: 'O nome é obrigatório',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Por favor, insira o ZSK',
    zskRequired: 'ZSK é obrigatório',
    cardNumLabel: 'Número da conta bancária',
    cardNumPlaceholder: 'Por favor, insira o número do cartão bancário',
    branchLabel: 'Endereço da agência',
    branchPlaceholder: 'Por favor, insira o endereço da agência bancária',
    fundPasswordLabel: 'Senha de fundos',
    fundPasswordPlaceholder: 'Por favor, insira a senha de fundos',
    tips:
      'O cartão bancário é um dado importante para retirada de dinheiro, preencha com cuidado. A empresa não se responsabiliza por problemas devido a informações incorretas.',
    backIdRequired: 'Por favor, selecione o banco da conta',
    cardNumRequired: 'Por favor, insira o número correto do cartão bancário',
    fundPwdRequired: 'Por favor, insira a senha de fundos correta',
    idCardPlaceholder: 'Por favor, insira seu número de identificação',
    idCardLabel: 'Número de identidade',
    idCardRequired: 'Por favor, insira o número de identificação correto',
    cciPlaceholder: 'Por favor, insira o CCI',
    branchCodePlaceholder: 'Por favor, insira o código da agência',
    branchCodeLabel: 'Código da agência',
    katakanaPlaceholder: 'Por favor, insira o katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Registro de Alteração de Conta',
    vcName: 'Moeda',
    amount: 'Quantidade',
    balance: 'Saldo'
  },
  timingTradeOrder: {
    title: 'Pedido de negociação temporizada',
    waiting: {
      title: 'Pedidos em andamento',
      amount: 'Quantidade',
      period: 'Período',
      receivePrice: 'Preço de compra',
      settlement: 'Liquidação em andamento'
    },
    history: {
      title: 'Pedidos históricos',
      buyInClose: 'Preço de compra',
      saleOutClose: 'Preço de venda'
    }
  },
  spotTradeOrder: {
    title: 'Pedidos de negociação à vista',
    waiting: {
      title: 'Pedidos pendentes',
      buyInAmount: 'Preço total de compra',
      buyInPrice: 'Preço unitário de compra',
      buyInCount: 'Quantidade comprada',
      buyInTime: 'Hora da compra'
    },
    history: {
      title: 'Pedidos históricos',
      buyInAmount: 'Preço total de compra',
      buyInPrice: 'Preço unitário de compra',
      buyInCount: 'Quantidade comprada',
      sellOutAmount: 'Preço total de venda',
      sellOutPrice: 'Preço unitário de venda',
      sellOutTime: 'Hora da venda'
    }
  },
  userReport: {
    title: 'Relatório do Usuário',
    profit: 'Lucro',
    timingTradeAmountFee: 'Pedido de negociação rápida/Taxa de manuseio',
    timingTradePrizePoint: 'Bônus de negociação rápida/Rebate',
    rechargeInfo: 'Recarga/Taxa de manuseio',
    withdrawInfo: 'Retirada/Taxa de manuseio',
    exchangeInfo: 'Troca/Taxa de manuseio'
  },
  userReportDay: {
    title: 'Relatório diário do usuário',
    profit: 'Lucro',
    timingTradeAmountFee: 'Pedido de negociação rápida/Taxa de manuseio',
    timingTradePrizePoint: 'Bônus de negociação rápida/Rebate',
    rechargeInfo: 'Recarga/Taxa de manuseio',
    withdrawInfo: 'Retirada/Taxa de manuseio',
    exchangeInfo: 'Troca/Taxa de manuseio'
  },
  teamReport: {
    goToReportDay: 'Relatório diário',
    timingTradeBetAmountServiceCharge:
      'Quantidade/Serviços de negociação rápida',
    timingTradeBetPrizePoint: 'Prêmio/Pontos de negociação rápida',
    timingTradeUserAndCount: 'Usuários/Contagens de negociação rápida',
    rechargeAmountFee: 'Quantidade/Serviços de recarga',
    rechargePersonCount: 'Usuários/Contagens de recarga',
    withdrawAmountFee: 'Quantidade/Serviços de retirada',
    withdrawPersonCount: 'Usuários/Contagens de retirada',
    firstRechargeUserAndCount: 'Primeira recarga/Contagens',
    title: 'Relatório da equipe',
    usernamePlaceholder: 'Digite o nome de usuário do nível inferior',
    previewAllTradeInfo: 'Visualizar todas as informações de negociação rápida',
    coin: 'Moeda',
    timingTradeBetAmount: 'Quantidade de apostas em negociação rápida',
    profit: 'Lucro',
    action: 'Operação',
    previewReportDay: 'Visualizar relatório diário'
  },
  teamTimingTradeInfo: {
    title: 'Negociação rápida da equipe',
    profit: 'Lucro',
    subTitle: 'Informações de negociação rápida da equipe',
    timingTradeAmountFee: 'Pedido de negociação rápida/Taxa de serviço',
    timingTradePrizePoint: 'Bônus de negociação rápida/Rebate',
    rechargeInfo: 'Recarga/Taxa de serviço',
    withdrawInfo: 'Retirada/Taxa de serviço',
    exchangeInfo: 'Troca/Taxa de serviço'
  },
  teamReportDay: {
    title: 'Relatório diário da equipe',
    subTitle: 'Relatório diário da equipe [ {username} ]',
    timingTradeBetAmountFee: 'Pedido de negociação rápida/Taxa de serviço',
    timingTradeUserAndCount: 'Usuários/Contagens de negociação rápida',
    timingTradeBetPrizePoint: 'Bônus/Rebate de negociação rápida',
    rechargeAmountFee: 'Quantidade de recarga/Taxa de serviço',
    rechargePersonCount: 'Usuários de recarga/Transações',
    firstRechargePersonCount: 'Primeira recarga/Contagens',
    withdrawAmountFee: 'Quantidade de retirada/Taxa de serviço',
    withdrawPersonCount: 'Usuários de retirada/Transações',
    exchangeAmountFee: 'Quantidade de troca/Taxa de serviço'
  },
  share: {
    title: 'Compartilhar',
    qrCodeLabel: 'Código QR',
    registerUrlLabel: 'Endereço de registro',
    inviteCodeLabel: 'Código de convite',
    hasNoInviteCode: 'A conta atual não possui código de convite,',
    generateInvitationCode: 'Tente gerar com um clique',
    tipsPart1:
      'Escaneie o código QR acima para preencher as informações de registro e registrar-se',
    tipsPart2:
      'Copie o endereço de registro e preencha as informações para registrar-se',
    tipsPart3:
      'Abra manualmente a interface de registro deste site e preencha o código de convite para registrar-se',
    saveImageError:
      'Falha ao salvar a imagem, tente pressionar longamente a imagem e salvar'
  },
  myTeam: {
    title: 'Minha equipe',
    usernamePlaceholder: 'Digite o nome de usuário do nível inferior',
    point: 'Rebate (rápido/contrato)',
    totalBalance: 'Saldo',
    lastLoginTime: 'Último horário de login',
    noLoginTime: 'Nenhum'
  },
  userDetail: {
    title: 'Detalhes do Usuário',
    username: 'Nome de Usuário',
    userType: 'Tipo de Usuário',
    pointPercentTiming: 'Rebate de Transação Rápida',
    pointPercentContract: 'Rebate de Transação de Contrato',
    registerWay: 'Método de Registro',
    teamCounts: 'Número da Equipe',
    teamOnline: 'Equipe Online',
    balance: 'Saldo',
    registerTime: 'Data de Registro',
    onlineStatus: 'Status de Login'
  },
  addUser: {
    title: 'Adicionar Usuário',
    addUserDirect: {
      userTypeLabel: 'Tipo de Usuário',
      usernameLabel: 'Nome de Usuário',
      usernamePlaceholder: 'Por favor, insira o nome de usuário da conta',
      pointTimingLabel: 'Rebate de Transação Rápida',
      pointContractLabel: 'Rebate de Transação de Contrato',
      tips:
        'A senha inicial é: "{password}"; por favor, lembre o usuário de alterar a senha após ativar a conta.',
      userTypeRequired: 'Por favor, selecione o tipo de conta',
      usernameRequired: 'Por favor, insira o nome de usuário da conta',
      pointTimingRequired: 'Por favor, selecione o rebate de transação rápida',
      pointContractRequired:
        'Por favor, selecione o rebate de transação de contrato',
      copyTemplate:
        'Nome de usuário: {username};\nSenha de login: {loginPassword};\nURL de Login: {loginAddress};\nRebate de transação rápida: {timingTradePoint};\nRebate de transação de contrato: {contactTradePoint};'
    }
  },
  recharge: {
    title: 'Recarga',
    configIdLabel: 'Canal de Recarga',
    chainNameLabel: 'Nome da Cadeia',
    amountLabel: 'Quantidade de Depósito',
    userCardNameLabel: 'Pagador',
    userCardNamePlaceholder: 'Por favor, insira o nome do pagador',
    fee: 'Taxa de Serviço',
    receiveAmountTipsPart1: 'Recarga',
    receiveAmountTipsPart2: ', Precisa pagar',
    tipsPart1:
      'Devido à instabilidade da interface de pagamento online, apenas transferência offline é suportada atualmente.',
    tipsPart2:
      'Preencha o valor real da transferência corretamente, caso contrário, pode haver falhas no processo de aprovação.',
    emptyPart1: 'Nenhum canal de recarga disponível,',
    emptyPart2: 'toque para tentar novamente',
    amountRequired: 'O valor da recarga não pode estar vazio',
    maxPrecisionError:
      'O valor da recarga pode ter no máximo {amountMaxPrecision} casas decimais',
    payUserNameError:
      'Por favor, insira corretamente o nome do pagador e tente novamente',
    userMobileLabel: 'Celular',
    userMobilePlaceholder: 'Por favor, insira seu número de celular',
    needPayLabel: 'Quantia a Pagar',
    needPayPlaceholder: 'Por favor, insira a quantia'
  },
  payDetail: {
    title: 'Informações de Transferência',
    addressLabel: 'Endereço de Depósito',
    rechargeAmount: 'Quantia',
    bankNameLabel: 'Banco',
    branchLabel: 'Endereço da Agência',
    cardName: 'Nome',
    cardNum: 'Número do Cartão',
    uploadImgLabel: 'Comprovante de Pagamento',
    uploadImgPlaceholder: 'Clique para enviar o comprovante de pagamento',
    uploadImgRequired: 'Por favor, envie o comprovante de pagamento',
    vcTransferTipsPart1:
      '1. Copie o endereço de depósito ou escaneie o código QR para depositar.',
    vcTransferTipsPart2:
      '2. Envie o comprovante de pagamento após concluir o depósito.',
    vcTransferTipsPart3:
      'Envie uma imagem nítida e de alta resolução do comprovante para evitar atrasos na aprovação.',
    bankCardTips:
      'Certifique-se de que o nome do remetente corresponda ao do titular da conta para evitar problemas de aprovação.',
    bankCardTransferSuccess: 'Transferência concluída com sucesso'
  },
  rechargeOrder: {
    title: 'Pedido de Depósito',
    payAmount: 'Valor Pago',
    receiveAmount: 'Valor Recebido'
  },
  identity: {
    title: 'Informações de Identidade',
    subTitle:
      'A autenticação de identidade inclui verificação de informações e identificação.',
    name: 'Nome',
    idType: 'Tipo de Documento',
    idNum: 'Número de Identificação',
    demand: 'Requisitos',
    informationVer: 'Verificação de Informações',
    idAuthentication: 'Autenticação',
    material: 'Materiais'
  },
  verified: {
    title: 'Autenticado',
    idCardTypeLabel: 'Tipo de Documento',
    idCardFrontSideImgLabel: 'Imagem da Frente do Documento',
    idCardBackSideImgLabel: 'Imagem do Verso do Documento',
    idCardHandSideImgLabel: 'Foto com o Documento em Mãos',
    nameLabel: 'Nome no Documento',
    namePlaceholder: 'Por favor, insira o nome do documento',
    idCardNumLabel: 'Número do Documento',
    idCardNumPlaceholder: 'Por favor, insira o número do documento',
    fundPwdLabel: 'Senha de Fundos',
    fundPwdPlaceholder: 'Por favor, insira sua senha de fundos',
    tips:
      'Uma vez enviada, a informação não pode ser alterada. Por favor, verifique antes de enviar.',
    idCardTypeRequired: 'Por favor, selecione o tipo de documento',
    idCardFrontSideImgRequired:
      'Por favor, envie a imagem da frente do documento',
    idCardBackSideImgRequired:
      'Por favor, envie a imagem do verso do documento',
    idCardHandSideImgRequired:
      'Por favor, envie uma foto segurando o documento',
    nameRequired: 'Por favor, insira o nome no documento',
    idCardNumRequired: 'Por favor, insira o número do documento',
    fundPwdRequired: 'Por favor, insira sua senha de fundos',
    submitSuccess: 'Solicitação de autenticação enviada com sucesso'
  },
  help: {
    title: 'Central de Ajuda'
  },
  helpDetail: {
    title: 'Detalhes da Ajuda'
  },
  myMessage: {
    title: 'Minhas Mensagens'
  },
  messageDetail: {
    title: 'Detalhes da Mensagem'
  },
  withdraw: {
    title: 'Retirar moedas',
    tips:
      'Para garantir a segurança dos fundos e a eficiência da retirada, por favor, verifique cuidadosamente se as informações preenchidas estão corretas. As taxas de serviço geradas durante o processo de retirada serão deduzidas do saldo.',
    receiveAmountTipsPart1: 'Retirar',
    receiveAmountTipsPart2: ', previsto para chegar',
    fee: 'Taxa de serviço',
    myBalance: 'Meu saldo de [{vcName}]:',
    configIdLabel: 'Canal de retirada',
    amountLabel: 'Valor da retirada',
    fundLabel: 'Senha de fundos',
    fundPlaceholder: 'Por favor, insira sua senha de fundos',
    googleCodeLabel: 'Código de verificação do Google',
    googleCodePlaceholder:
      'Por favor, insira o código de verificação de 6 dígitos do Google',
    maxPrecisionError:
      'O valor da retirada pode ter no máximo {amountMaxPrecision} casas decimais',
    amountRequired:
      'Por favor, insira ou selecione o valor correto para a retirada',
    bankCardError: 'Por favor, selecione o cartão bancário correto',
    fundPwdError: 'Por favor, insira a senha de fundos correta',
    walletAddressError: 'Por favor, selecione o endereço da carteira correto',
    success:
      'A solicitação de retirada foi enviada com sucesso. Aguarde o processamento.',
    emptyPart1: 'Não há canal de retirada disponível,',
    emptyPart2: 'toque para tentar novamente'
  },
  withdrawOrder: {
    title: 'Pedido de retirada',
    requestAmount: 'Valor solicitado',
    receiveAmount: 'Valor recebido'
  },
  locales: {
    title: 'Mudar idioma'
  },
  lines: {
    title: 'Linhas',
    switchLine: 'Trocar linha'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Moeda favorita removida com sucesso',
    addFavoriteSuccess: 'Moeda favorita adicionada com sucesso'
  },
  currencySelect: {
    currencyName: 'Moeda',
    currencyPlaceholder: 'Clique para selecionar a moeda'
  },
  walletItem: {
    available: 'disponível',
    convert: 'converter (USDT)'
  },
  banks: {
    bankIdLabel: 'Banco',
    bankIdPlaceholder: 'Clique para selecionar um banco'
  },
  banksPop: {
    title: 'Selecionar banco',
    search: 'Digite as palavras-chave do banco'
  },
  historyOrderDetail: {
    title: 'Detalhes do pedido',
    coin: 'Moeda da transação',
    amount: 'Valor do pedido',
    buyInClose: 'Preço de compra',
    sellOutClose: 'Preço de venda',
    isQuest: 'Tem alguma dúvida sobre este pedido?',
    connectCustomer: 'Entrar em contato com o atendimento ao cliente?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Clique para selecionar o rebate do usuário'
  },
  walletAddressSelect: {
    title: 'Selecionar endereço da carteira',
    label: 'Endereço da carteira',
    placeholder: 'Clique para selecionar o endereço da carteira'
  },
  myCardSelect: {
    title: 'Selecionar conta',
    label: 'Conta de recebimento',
    placeholder: 'Clique para selecionar uma conta'
  },
  amountInput: {
    amountRange: 'Mín {minAmount}, Máx {maxAmount}',
    amountMin: 'Mín {minAmount}, Sem limite superior',
    amountErrorEmpty: '{label} é obrigatório',
    amountErrorOutRange: '{label} está fora do intervalo'
  },
  amountFormItem: {
    placeholderOnlyMin: 'Mín {minAmount}, Sem limite superior',
    placeholderHasMax: 'Mín {minAmount}, Máx {maxAmount}',
    amountErrorEmpty: 'O valor está incorreto',
    amountErrorOutRange: 'O valor está fora do intervalo'
  },
  common: {
    remark: 'Observação',
    saveImage: 'Salvar imagem',
    online: 'Online',
    offline: 'Offline',
    profit: 'Lucro',
    date: 'Data',
    period: 'Período',
    pointAmount: 'Quantidade de pontos',
    point: 'Rebate do usuário',
    direction: 'Direção',
    winLoss: 'Rendimento',
    lose: 'Perda',
    add: 'Adicionar',
    win: 'Ganho',
    edit: 'Modificar',
    notBind: 'Não vinculado',
    alreadyBind: 'Já vinculado',
    enabled: 'Habilitado',
    notEnabled: 'Não habilitado',
    queryRange: 'Intervalo de consulta',
    copy: 'Copiar',
    orderNum: 'Pedido',
    null: 'Nulo',
    noData: 'Sem dados',
    refreshSuccess: 'Atualização bem-sucedida',
    loadMoreData: 'Carregar mais dados',
    noMoreData: 'Não há mais dados',
    lookMore: 'Mais',
    more: 'Mais'
  },
  date: {
    today: 'Hoje',
    yesterday: 'Ontem',
    last7Days: 'Últimos 7 dias',
    last14Days: 'Últimos 14 dias',
    split: 'Até'
  },
  button: {
    save: 'Salvar',
    logout: 'Sair',
    confirm: 'OK',
    cancel: 'Cancelar',
    submit: 'Enviar',
    addNow: 'Adicionar agora',
    reset: 'Redefinir',
    nextStep: 'Próximo',
    goCertification: 'Ir para certificação'
  },
  confirm: {
    title: {
      logout: 'Sair',
      unBindFundPassword: 'Senha de fundos não vinculada',
      addUserDirect: 'Adicionar usuário',
      addUserInfo: 'Usuário adicionado com sucesso',
      jumpToRechargePage: 'Confirmar redirecionamento',
      unAuthentication: 'Não autenticado',
      noBindBankCard: 'Sem cartão bancário',
      noBindCoinAddress: 'Sem endereço de carteira',
      tradeConfirm: 'Confirmar transação',
      sellOutSpotOrder: 'Vender posição',
      buyFinance: 'Confirmar compra',
      redeemOrder: 'Resgatar pedido'
    },
    content: {
      logout: 'Tem certeza de que deseja sair da conta atual?',
      unBindFundPassword:
        'Foi detectada uma senha de fundos não vinculada. Para garantir a segurança da conta, vincule sua senha de fundos primeiro.',
      addUserDirect:
        'Um novo usuário será adicionado em breve. Verifique se as informações estão corretas e clique em OK para continuar. Nome do usuário [{username}], tipo de usuário [{userType}], senha de login [{password}], diferença do meu rebate de transação rápida [{diffPointTiming}], diferença do meu rebate de transação de contrato [{diffPointContract}].',
      addUserInfo:
        'Nome de usuário [{username}]; <br /> Senha de login [{password}];<br /> URL de login [{loginAddress}];<br /> Rebate de transação extrema [{pointPercentTiming}];<br /> Rebate de transação de contrato [{pointPercentContract}];',
      jumpToRechargePage:
        'Você será redirecionado para a interface de recarga terceirizada. Clique em confirmar para continuar.',
      unAuthentication:
        'Detectamos que a conta não possui autenticação com nome real. Para garantir a circulação normal dos fundos, realize a autenticação primeiro.',
      noBindBankCard:
        'Detectamos que a conta não possui cartão bancário vinculado. Para garantir a circulação normal dos fundos, vincule o cartão bancário primeiro.',
      noBindCoinAddress:
        'Detectamos que a conta não possui endereço de moeda virtual vinculado. Para garantir a circulação normal dos fundos, adicione o endereço da moeda virtual primeiro.',
      tradeConfirm:
        'O pedido será enviado. Verifique se as informações do pedido estão corretas e clique em Confirmar Pedido para enviar.',
      sellOutSpotOrder:
        'A ordem de posição será vendida. Verifique se a operação está correta e clique em OK para continuar.',
      buyFinance:
        'Você está prestes a comprar [{coin}], quantidade: {amount}. Verifique se a operação está correta e clique em OK para continuar.',
      redeemOrder:
        'O pedido de penhor ({orderNum}) será resgatado. Verifique se a operação está correta e clique em Confirmar para continuar.'
    }
  },
  message: {
    bindSuccess: 'Vinculado com sucesso',
    successOperation: 'Operação bem-sucedida',
    logoutSuccess: 'Saída bem-sucedida',
    editSuccess: 'Modificado com sucesso',
    addSuccess: 'Adicionado com sucesso',
    copySuccess: 'Cópia bem-sucedida',
    copyFailed: 'Falha na cópia'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Domingo',
      week_day_1: 'Segunda',
      week_day_2: 'Terça',
      week_day_3: 'Quarta',
      week_day_4: 'Quinta',
      week_day_5: 'Sexta',
      week_day_6: 'Sábado'
    },
    loading: {
      loading: 'Carregando'
    }
  },
  helpItems: {
    title: {
      part1: 'Por que o valor convertido em ativos muda?',
      part2: 'Esqueceu a senha de fundos para transações OTC? Como resolver?',
      part3:
        'Para onde os fundos vão após a conclusão da compra em transações OTC?',
      part4: 'Por que é necessário limitar o número de alterações de apelido?',
      part5: 'O que significa transferência e por que é necessária?',
      part6: 'Como calcular o patrimônio da conta do usuário em contratos?',
      part7:
        'O que significam os valores de stop loss e take profit definidos na abertura de posição? Como configurá-los?',
      part8: 'Como reduzir o risco de contrato?',
      part9: 'O que significa a quantidade na posição aberta do contrato?',
      part10: 'Instruções sobre liquidação forçada',
      part11: 'Quais são as regras de negociação de contratos?',
      part12: 'O que é margem em negociações de contrato?',
      part13: 'O que é ordem limitada e ordem de mercado?',
      part14: 'O que representa o risco em transações de contrato?',
      part15: 'Por que é necessária a conversão de moeda?',
      part16:
        'Por que a outra parte não recebeu a transferência em tempo hábil após a transação OTC?',
      part17: 'Como comprar Tether (USDT) via OTC?'
    },
    content: {
      part1:
        'O valor da moeda digital atualmente mantido em Renminbi ao ser convertido em ativos mudará devido às flutuações de preço dos ativos digitais. A quantidade de seus ativos digitais não mudou.',
      part2:
        "Se você esquecer a senha de fundos de transação OTC, acesse 'Minha conta - Configurações - Clique para definir a senha de fundos' ou entre em contato com o atendimento ao cliente para redefini-la.",
      part3:
        'Após a conclusão da ordem de compra OTC, os fundos serão transferidos para a conta de moeda fiduciária no ativo. Caso precise usar os ativos comprados via OTC para negociações de contrato ou futuros, acesse o módulo de transferência de fundos para transferir.',
      part4:
        'Por razões de segurança em suas transações, atualmente limitamos a alteração do apelido a apenas uma vez.',
      part5:
        'Para garantir a independência dos fundos entre suas várias contas e facilitar seu controle de risco, as contas dos principais módulos de negociação foram divididas. Transferência refere-se ao processo de conversão mútua de ativos entre diferentes contas de negociação.',
      part6:
        '<p>O patrimônio da conta do contrato é calculado da seguinte forma:</p> <p>Patrimônio da conta do contrato = margem da posição + lucro e prejuízo flutuante da posição + valor disponível da conta atual</p>',
      part7:
        'Take profit (realização de lucro) e stop loss (limitação de perda) são limites definidos por você. Quando o valor definido é atingido, o sistema fechará automaticamente a posição. Isso pode ser usado para controlar riscos ao negociar contratos. Recomendamos que você configure isso com base na sua situação financeira para gerenciar os riscos de forma razoável.',
      part8:
        'Você pode transferir os ativos disponíveis de outras contas para a conta de contrato, ou reduzir o risco diminuindo a posição.',
      part9:
        'A quantidade na posição aberta indica a quantidade de moeda que você espera comprar. Por exemplo: na página de abertura da negociação BTC/USDT, escolha comprar, insira o preço de 1000USDT e a quantidade de 10BTC. Isso significa que você espera comprar 10 BTC a um preço unitário de 1000USDT.',
      part10:
        '<p>O grau de risco é um indicador que mede o risco dos seus ativos. Quando o grau de risco for igual a 100%, sua posição será liquidada. Para evitar que os usuários excedam suas posições, o sistema define um índice de ajuste de risco. Quando o grau de risco atingir o valor definido pelo sistema, o sistema forçará a liquidação.</p> <p>Nota: Se a liquidação for forçada devido a risco excessivo, todas as suas posições serão encerradas. Portanto, controle seus riscos de forma razoável para evitar perdas desnecessárias.</p>',
      part11:
        '<p>Tipo de negociação</p> <p>O tipo de negociação é dividido em dois: abrir posição longa (compra) e abrir posição curta (venda):</p> <p>Comprar longo significa que você acredita que o índice atual pode subir e deseja comprar uma certa quantidade de contratos a um preço definido ou ao preço de mercado.</p> <p>Vender curto significa que você acredita que o índice atual pode cair e deseja vender uma certa quantidade de contratos a um preço definido ou ao preço de mercado.</p>',
      part12:
        '<p>Em negociações de contrato, o usuário participa das negociações pagando uma garantia (margem) com base no preço e na quantidade do contrato. Este valor é a margem do contrato. Quanto maior a margem utilizada, maior o risco.</p>',
      part13:
        'Ordem limitada refere-se ao preço que você espera para executar a transação. Ordem de mercado refere-se à execução da transação ao preço atual. Ordens de mercado têm prioridade sobre ordens limitadas.',
      part14:
        'O nível de risco é um indicador do seu risco em negociações de contrato. Sugerimos cautela ao abrir posições com risco superior a 50%.',
      part15:
        'A conversão de moeda permite a circulação fluida de fundos entre diferentes contas e moedas.',
      part16:
        'Certifique-se de que o método de pagamento usado é exatamente igual ao mostrado na página de detalhes do pedido. Se necessário, entre em contato com seu banco para mais informações.',
      part17:
        '<p>Método 1: Escolha um pedido na lista de compra/venda OTC para realizar a transação.</p> <p>Método 2: Publique seu próprio pedido e aguarde o sistema encontrar um comprador ou vendedor correspondente.</p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/pt.js